import { Paper, Stack } from '@mui/material'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import CustomTypography from '@/components/dataDisplay/CustomTypography'
import EditableBox from '@/features/site/components/EditableBox'
import EditIconButton from '@/features/site/components/EditIconButton'
import { SiteActivationOrderSettingsDisplay } from '@/features/site/components/settings/activation_order/SiteActivationOrderSettingsDisplay'
import type { Site } from '@/features/site/types/site'

import { SiteActivationOrderSettingsForm } from './form/SiteActivationOrderSettingsForm'

interface SiteActivationOrderSettingsProps {
  site: Site
}

export const SiteActivationOrderSettings = ({ site }: SiteActivationOrderSettingsProps) => {
  const { t } = useTranslation()
  const [isEditable, setIsEditable] = useState(false)
  const [isTopPriorityPlacement, setIsTopPriorityPlacement] = useState(site.isTopPlacementPriority)

  function handleTopPlacementPriorityChange(isTopPriorityPlacement: boolean) {
    switchToEditMode()
    setIsTopPriorityPlacement(isTopPriorityPlacement)
  }

  function switchToEditMode() {
    setIsEditable(true)
    setIsTopPriorityPlacement(site.isTopPlacementPriority)
  }

  function switchToReadMode() {
    setIsEditable(false)
    setIsTopPriorityPlacement(site.isTopPlacementPriority)
  }

  return (
    <Paper sx={{ p: 3, height: 'fit-content', width: '100%' }}>
      <Stack gap={2}>
        <Stack alignItems="center" flexDirection="row" justifyContent="space-between">
          <CustomTypography variant="h5">{t('sites.activation_order_settings.title')}</CustomTypography>

          {!isEditable && (
            <EditIconButton tooltipText={t('customer_details.tabs.settings.edit_label')} onClick={switchToEditMode} />
          )}
        </Stack>

        <EditableBox isEditable={isEditable}>
          {isEditable ? (
            <SiteActivationOrderSettingsForm
              isTopPlacementPriority={isTopPriorityPlacement!}
              site={site}
              onReset={switchToReadMode}
              onSubmit={switchToReadMode}
            />
          ) : (
            <SiteActivationOrderSettingsDisplay
              isTopPlacementPriority={site.isTopPlacementPriority}
              onTopPlacementPriorityChange={handleTopPlacementPriorityChange}
            />
          )}
        </EditableBox>
      </Stack>
    </Paper>
  )
}
